<footer class="footer">
  <div class="container container_type_footer">
    <div class="footer__line">
      <div class="footer__left">
        <div class="footer__copyright">{{'footer.copyright' | translate:{year: year} }}</div>
        <div class="footer__text footer__text-style" [innerHtml]="'footer.agreement' | translate:{appUrl: appUrl}"></div>
      </div>
      <div class="footer__right" [innerHtml]="'footer.phone' | translate"></div>
    </div>
    <div class="footer__text-mobile footer__text-style" [innerHtml]="'footer.agreement' | translate"></div>
  </div>
</footer>
